// extracted by mini-css-extract-plugin
module.exports = {"metricColumnWrap":"MetricColumn_metricColumnWrap__iBofB","title":"MetricColumn_title__2PwGO","metricList":"MetricColumn_metricList__2wMCS"};